import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepParticipantsFormContainer from '../../../../containers/projects/StakeholderFormContainers/StepCommunicatorsFormContainer.jsx';

const NewProfileStepParticipants = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>New Stakeholder | ChangeSync</title>
    </Helmet>
    <StepParticipantsFormContainer projectId={projectId} slug={slug} />
  </>
);

NewProfileStepParticipants.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewProfileStepParticipants));
